import { Component, Input, OnInit } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
    selector: 'icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: true,
    imports: [MatIconModule]
})
export class IconComponent implements OnInit {
  @Input() name: string

  /**
   * Track which icon names have a registered local SVG. Used to decide if we show an <mat-icon svgIcon>
   * or fall back to Material Symbols font ligature (no manual SVG file required).
   */
  private static registeredSvgNames = new Set<string>();

  public constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    const add = (n: string, file: string) => {
      iconRegistry.addSvgIcon(n, sanitizer.bypassSecurityTrustResourceUrl(`assets/${file}`));
      IconComponent.registeredSvgNames.add(n);
    };
    // Local / brand / custom icons (keep these curated)
    add("logo", "logo.svg");
    add("facebook", "facebook.svg");
    add("youtube", "youtube.svg");
    add("twitter", "twitter.svg");
    add("linkedin", "linkedin.svg");
    add("menu", "menu.svg");
    add("search", "search.svg");
    add("call", "call.svg");
    add("call_filled", "call_filled.svg");
    add("location_on", "location_on.svg");
    add("location_on_filled", "location_on_filled.svg");
    add("navigate_next", "navigate_next.svg");
    add("business", "business.svg");
    add("work", "work.svg");
    add("schedule", "schedule.svg");
    add("schedule_filled", "schedule_filled.svg");
    add("school", "school.svg");
    add("school_filled", "school_filled.svg");
    add("tune", "tune.svg");
    add("done", "done.svg");
    add("close", "close.svg");
    add("blauwtand", "blauwtand.svg");
    add("sentiment_dissatisfied", "sentiment_dissatisfied.svg");
    add("email", "email.svg");
    add("email_filled", "email_filled.svg");
    add("euro", "euro.svg");
    add("hourglass", "hourglass.svg");
    add("hourglass_filled", "hourglass_filled.svg");
    add("whatsapp", "whatsapp.svg");
    add("account_circle", "account_circle.svg");
    add("file_upload", "file_upload.svg");
    add("file", "file.svg");
    add("instagram", "instagram.svg");
    add("search_off", "search_off.svg");
    add("link", "link.svg");
    // Alias person -> account_circle
    iconRegistry.addSvgIcon("person", sanitizer.bypassSecurityTrustResourceUrl("assets/account_circle.svg"));
    IconComponent.registeredSvgNames.add("person");
    // We intentionally do NOT add 'error' or 'refresh' to force font fallback unless custom SVGs are later supplied.
  }

  public hasLocalSvg(): boolean {
    return IconComponent.registeredSvgNames.has(this.name);
  }

  public ngOnInit(): void {}
}
